import React from 'react'

const Dashboards = () => {
  return (
    <div>Dashboards</div>
  )
}

export default Dashboards